// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6066) return "static/chunks/6066-af4465c0f9603e3e2ff4.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7851":"0b63ce986b0cd37b1a0c","8986":"35e996fad7495476a881"}[chunkId] + ".js";
};